import React from 'react'
import Logo from '../logo/logo'
import { GiHamburgerMenu } from "react-icons/gi";
import { useRouter } from '../../pages/routes/hooks/use-router';
import { useAuthContext } from '../../auth/hooks';
import ProfileDropdown from './profile-dropdown';
import useResponsiveStore from '../../store/responsive-store';
const Header = () => {
  const router=useRouter()
  const { logout } = useAuthContext();
  const userDetails=JSON.parse(localStorage.getItem('userDetails'))
  const { responsiveData } = useResponsiveStore();
const handleLogout=()=>{
  logout()
  router.push("/auth/login")
}
  return (
    <div className='k-py-4 k-px-10 k-elevation-3 k-display-flex k-justify-content-between' style={{backgroundColor:"#FFF"}}>
        <div className='k-display-flex'>
        <Logo/>
        {/* <GiHamburgerMenu className='k-mt-3 k-mx-10 k-cursor-pointer'/> */}
        </div>
         {!responsiveData.isMobile ? <div className=''>
            <p className='k-m-0'>{userDetails?.email || ''}</p>
            <p className='k-m-0 k-text-right k-pt-2 k-cursor-pointer' onClick={handleLogout}>Logout</p>
         </div> : <ProfileDropdown email={userDetails?.email} logout={handleLogout}/>}
         
    </div>
  )
}

export default Header